import * as React from 'react';

export default function CustomSponsorIcon({
  color = 'primary',
}: {
  color: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 40"
    >
      <path
        fill={color}
        d="m0 40 10.036-9.835L20.072 40V0H0ZM8.373 8.513l2.092-4.238 2.092 4.238 4.677.68-3.384 3.3.8 4.658-4.183-2.2-4.183 2.2.8-4.658-3.384-3.3Z"
        data-name="Icon sponsor"
      />
    </svg>
  );
}
